export const HANDLE_GET_TECHPACK_LIST ="HANDLE_GET_TECHPACK_LIST";
export const HANDLE_UPLOAD_TECHPACK_FILE ="HANDLE_UPLOAD_TECHPACK_FILE";
export const HANDLE_GET_UPLOADED_FILE_URL ="HANDLE_GET_UPLOADED_FILE_URL";
export const HANDLE_TECHPACK_PARSE ="HANDLE_TECHPACK_PARSE"
export const HANDLE_UPDATE_TECHPACK_PARSE ="HANDLE_UPDATE_TECHPACK_PARSE";
export const HANDLE_SUCCESS_TECHPACK_PARSE ="HANDLE_SUCCESS_TECHPACK_PARSE";
export const HANDLE_FAILED_TECHPACK_PARSE ="HANDLE_FAILED_TECHPACK_PARSE"
export const HANDLE_DEBOUCE_UPDATE_TECHPACK_PARSE ="HANDLE_DEBOUCE_UPDATE_TECHPACK_PARSE"
export const HANDLE_SUBMIT_FEEDBACK = "HANDLE_SUBMIT_FEEDBACK";
export const HANDLE_BATCH_FILE_UPLOAD = "HANDLE_BATCH_FILE_UPLOAD";